module.exports = __webpack_public_path__ + "fonts/DINPro-Medium.a999b125.ttf";